__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['virtual-cards-root'].baseUrl;
import ModuleContainer from './components/VirtualCardsRoot';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}